<template>
  <div>
    <div class="container">
      <section-label value="Verificar resultados por:" />
      <wrap-container class="cascade w50"></wrap-container>

      <wrap-container class="grid-container container c-radio">
        <radio-item
          class="col1 radio"
          optionValue="2"
          @input="onSearchType"
          label="Calle / Localidad"
        />
        <radio-item
          class="col2 radio"
          optionValue="1"
          @input="onSearchType"
          label="Código Postal"
        />
      </wrap-container>

      <div class="result-search" v-if="model.list.length > 0">
        <section-label value="Seleccioná un de las siguientes opciones:" />

        <wrap-container class="cascade w50"></wrap-container>

        <wrap-container class="grid-container grid-container--4-4-4 header">
          <span class="col1">Código postal</span>
          <span class="col2">Calle/Localidad</span>
          <span class="col3">Nº Puerta</span>
        </wrap-container>

        <wrap-container
          class="grid-container grid-container--4-4-4 table search-list"
          v-for="(item, index) in model.list"
          v-bind:key="index"
        >
          <radio-item
            class="col1 radio m-left20"
            :optionValue="index"
            @input="onSelectValid"
            :label="item.codigoPostal"
          />
          <p class="col2">{{ item.calleLocalidad }}</p>
          <p class="col3">
            {{ item.numeroPuertaDesde }} - {{ item.numeroPuertaHasta }}
          </p>
        </wrap-container>
      </div>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SectionLabel from "@/components/core/SectionLabel";
import RadioItem from "@/components/core/custom/RadioItem";
import { DO_SEARCH_ENCOTESA } from "@/config/constants/action-types";
export default {
  name: "SearchEncontesa",
  components: {
    WrapContainer,
    SectionLabel,
    RadioItem
  },
  props: {
    domicilio: Object,
    searchEncontesa: Boolean,
    otroDomicilio: Boolean,
    step4: Boolean
  },
  data() {
    return {
      model: this.$store.getters.getSearchEncontesa()
    };
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getSearchEncontesa,
      model => {
        // Obtengo el name de la vista para agregar clase general al div#app
        this.model = model;
      },
      { immediate: true }
    );
  },
  methods: {
    onSearchType(search) {
      if (search.label) {
        this.model.domicilio.codigoPostal = search.label;
        this.model.searchType = search.searchType;
        this.$store.dispatch(DO_SEARCH_ENCOTESA, this.model);
      } else {
        this.model.domicilio = this.domicilio;
        this.model.searchType = search;
        this.$store.dispatch(DO_SEARCH_ENCOTESA, this.model);
      }
    },
    onSelectValid(domIndex) {
      if (this.step4) {
        this.$emit("selectValid");
      }
      if (this.otroDomicilio) {
        this.$store.dispatch(
          "doSelectEncotesaAlternativo",
          this.model.list[domIndex]
        );
      } else {
        this.$store.dispatch(
          "doSelectEncotesaParticular",
          this.model.list[domIndex]
        );
      }
    }
  }
};
</script>

<style scoped>
.radio {
  width: 190px;
  height: 61px;
  border-radius: 1px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  padding-left: 16px;
  margin-right: 12px;
}

.m-left20 {
  margin-left: 18px;
}

.table {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
}
.table .radio {
  height: 61px;
  border-radius: 1px;
  border: none;
  box-shadow: none;

  padding-left: 0px;
  background-color: #ffffff;
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
}
.table > p {
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  padding: 0px;
}
.header {
  padding: 0 18px !important;
}

.header > span {
  width: 56px;
  height: 17px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #121212;
  text-align: left;
}

.result-search .grid-container {
  margin-bottom: 7px;
}

.search-list {
  margin-bottom: 7px !important;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
  }

  .header > span {
    padding: 0 18px 0 0;
  }

  .search-list {
    display: inline-flex !important;
    padding: 0 10px !important;
  }

  .search-list .col1,
  .search-list .col2,
  .search-list .col3 {
    margin: 0 !important;
  }
  .search-list .radio {
    width: 120px;
    display: flex;
    margin: 0;
  }
}

@media screen and (max-width: 415px) {
  .container {
    padding: 0;
    white-space: normal;
    text-align: left;
  }
  .radio {
    width: 240px;
    display: flex;
    margin-left: 12px;
  }
}
</style>
